export const HIGHLIGHT_COLORS = ['clear', '#eff29b', '#76ede3', '#98ed76', '#f0c3b5', '#ececec'];
